import { RuleFactory } from "./factory"

export const rules = {
  announcementVideoTitle: [RuleFactory.required("Title")]
}
